import styled, { useTheme } from "styled-components";
import CheckboxField from "../../../../components/FormFields/CheckboxField";
import Icon from "../../../../components/Icon/Icon";
import { useEffect, useState } from "react";
import { LiveToolsSettings } from "../JudgingInterfaces";
import replaceSingleEntry from "../../../Judging/replaceSingleEntry";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";

const StyledGridHeader = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
  margin: 1rem 1.5rem 2rem 1.5rem;
  padding: 1rem 1.5rem;
  background: ${({ theme }) => theme.colorBackgroundLight};
  border-left: 3px solid ${({ theme }) => theme.colorActivation};
`;

const EntryGridHeader = (props: {
  settings: LiveToolsSettings;
  updateEntriesLocked: (isLocked: boolean) => void;
  onClickFilter(): void;
}) => {
  const theme = useTheme();
  const { labels } = useSelector((state: RootState) => state.labels);
  const [lockAll, setLockAll] = useState(props.settings.entriesLocked);

  useEffect(() => {
    setLockAll(props.settings.entriesLocked);
  }, [props.settings.entriesLocked]);

  return (
    <StyledGridHeader>
      <b className="max-w-full break-words">
        {replaceSingleEntry(labels, props.settings.entryDisplayTitlePreview)}
      </b>
      <div className="flex items-center gap-[1rem] ml-auto">
        <CheckboxField
          className="ml-auto"
          name="lockAll"
          placeholder="Lock All"
          checked={lockAll}
          nonFormik
          onChange={(isChecked) => {
            setLockAll(isChecked);
            props.updateEntriesLocked(isChecked);
          }}
        />
        <Icon
          icon="filter"
          color={theme.colorPrimary}
          onClick={() => props.onClickFilter()}
        />
      </div>
    </StyledGridHeader>
  );
};

export default EntryGridHeader;
